import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, IndexLink } from 'react-router';
import * as routes from '../constants/routesNames';
import ReactGA from 'react-ga';
import { I18n } from 'react-redux-i18n';

class HeaderButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    };
  }

  handleMenuToggle() {
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  }

  handleBackPress() {
    ReactGA.event({
      category: 'Navigation',
      action: 'Back'
    });
  }

  render() {
    const { noBack, noMenu } = this.props;
    const menu = I18n.t('menu');

    let menuButton;

    if (!noMenu) {
      if (!this.state.menuOpen) {
        menuButton = <img src={require('../assets/images/ic_menu.svg')} />;
      } else {
        menuButton = <img src={require('../assets/images/ic_close.svg')} />;
      }
    }

    return (
      <div className="header-buttons">
        {!noBack &&
          <IndexLink
            to={routes.HOMEPAGE}
            className="back-button"
            onClick={() => this.handleBackPress()}
          >
            <img src={require('../assets/images/ic_chevron_left.svg')} />
          </IndexLink>}

        {!noMenu &&
          <div id="menu-wrapper">
            <div
              onClick={() => this.handleMenuToggle()}
              className="menu-button"
            >
              {menuButton}
            </div>

            <div
              id="menu"
              className={this.state.menuOpen ? 'open' : ''}
              onClick={() => this.handleMenuToggle()}
            >
              <div id="menu-header">
                <img
                  className="logo"
                  src={require('../assets/images/logo_f_white.svg')}
                />
              </div>
              <div className="menu-items">
                <Link to={routes.HOMEPAGE}>
                  {menu.projects}
                </Link>
                <Link to={routes.CONTACT}>
                  {menu.contact}
                </Link>
                <a href="https://www.linkedin.com/company/10040924/" target="_blank">Linkedin</a>
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

HeaderButtons.propTypes = {
  noBack: PropTypes.bool,
  noMenu: PropTypes.bool
};

export default HeaderButtons;



// WEBPACK FOOTER //
// ./src/components/HeaderButtons.js